import {
  breakpointSizes,
  getBreakpointOnly,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useState } from 'react'
import Box from 'src/components/Box/Box'
import Collapsible from 'src/components/Collapsible/Collapsible'
import SvgChevronDown from 'src/components/Svgs/SvgChevronDown'
import SvgChevronUp from 'src/components/Svgs/SvgChevronUp'
import { css } from 'styled-components'

interface BottomBoxProps {
  className?: string
  label: React.ReactNode
  isExpense?: boolean
  closedByDefault?: boolean
  collapsible?: boolean
  testId?: string
}

const BottomBox: React.FC<React.PropsWithChildren<BottomBoxProps>> = (
  props,
): React.ReactElement => {
  const [isBottomOpen, setIsBottomOpen] = useState(
    props.closedByDefault ? !props.closedByDefault : true,
  )

  const onClick = (): void => {
    setIsBottomOpen(!isBottomOpen)
  }

  return (
    <Box
      className={props.className}
      noPadding
      testId={props.testId}
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        css={css`
          padding: ${styleConstants.heights.cardPadding}
            ${styleConstants.widths.cardPaddingXSMUp};
          display: flex;
          justify-content: space-between;
          align-items: center;

          ${getBreakpointOnly(breakpointSizes.XXSM)(css`
            padding: ${styleConstants.heights.cardPadding}
              ${styleConstants.widths.cardPaddingXXSMOnly};
          `)}
        `}
      >
        <div
          css={css`
            ${getFontCss(
              16,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )}

            ${!!props.isExpense &&
            css`
              ${getFontCss(
                20,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )}
            `}
          `}
        >
          {props.label}
        </div>
        {props.collapsible && (
          <div
            onClick={onClick}
            onKeyPress={onClick}
            role="button"
            tabIndex={0}
            css={css`
              cursor: pointer;
            `}
          >
            {isBottomOpen && <SvgChevronUp />}
            {!isBottomOpen && <SvgChevronDown />}
          </div>
        )}
      </div>
      {props.collapsible ? (
        <Collapsible isOpen={isBottomOpen}>
          <div
            css={css`
              padding: 0px ${styleConstants.widths.cardPaddingXSMUp}
                ${styleConstants.heights.cardPadding};

              ${getBreakpointOnly(breakpointSizes.XXSM)(css`
                padding: 0px ${styleConstants.widths.cardPaddingXXSMOnly}
                  ${styleConstants.heights.cardPadding};
              `)}
            `}
          >
            {props.children}
          </div>
        </Collapsible>
      ) : (
        <div
          css={css`
            padding: 0px ${styleConstants.widths.cardPaddingXSMUp}
              ${styleConstants.heights.cardPadding};

            ${getBreakpointOnly(breakpointSizes.XXSM)(css`
              padding: 0px ${styleConstants.widths.cardPaddingXXSMOnly}
                ${styleConstants.heights.cardPadding};
            `)}
          `}
        >
          {props.children}
        </div>
      )}
    </Box>
  )
}

export default BottomBox
